// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-modal__nofooter .ant-modal-footer {\n  display: none;\n}\n.x-modal .ant-modal-body {\n  padding-bottom: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
